import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import AddIcon from '@mui/icons-material/AddOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import SearchIcon from '@mui/icons-material/Search';
import DeleteConfirmation from '../../components/MultiDeleteConfirmation';
import { Button, Row, Col, UncontrolledTooltip } from 'reactstrap';
import Search from '../poc/Search';
import { DataGrid } from '@mui/x-data-grid';

const List = (props) => {
    const [deleteConfirmationState, setDeleteConfirmationState] = useState({
        display: false,
        toDelete: [],
    });
    const [deleteEnabled, setDeleteEnabled] = useState(false);

    const handleDelete = () => {
        props.deleteContacts(deleteConfirmationState.toDelete.map(x => x.personId));
        setDeleteConfirmationState({
            display: false,
            toDelete: [],
        });
    }

    const handleDeleteConfirmationToggle = () => setDeleteConfirmationState({
        display: !deleteConfirmationState.display,
        toDelete: deleteConfirmationState.toDelete
    });

    const handleDeleteClick = (e) => {
        setDeleteConfirmationState({
            display: true,
            toDelete: deleteConfirmationState.toDelete
        });
    }
    
    const handleSelectionChanged = (selectionModel) => {
        if (selectionModel.length > 0) {
            const selectedRows = props.data.filter(x => selectionModel.includes(x.personId));
            setDeleteEnabled(true);
            setDeleteConfirmationState({
                display: false,
                toDelete: selectedRows
            });
        } else {
            setDeleteEnabled(false);
            setDeleteConfirmationState({
                display: false,
                toDelete: []
            });
        }
    };

    return (
        <>
            {!props.hideButtons && (
                <Row className='mb-1'>
                    <Col>
                        <h3>{props.title}</h3>
                    </Col>
                    <Col className='d-flex flex-row-reverse'>
                        <Button id='deleteButton' disabled={!deleteEnabled} onClick={handleDeleteClick}>
                            <DeleteIcon />
                        </Button>
                        <UncontrolledTooltip delay={{ show: 0, hide: 0 }} target='deleteButton'>
                            Delete points of contact.
                        </UncontrolledTooltip>
                    </Col>
                </Row>
            )}
            <Row className='mb-1'>
                <Col>
                    <div className='ag-theme-balham' style={{ width: 'auto' }}>
                        <DataGrid
                            rows={props.data.map(x => ({
                                id: x.personId,
                                ...x,
                                programNames: x.assignedPrograms?.map(p => p.name).join(', ') || '',
                            }))}
                            checkboxSelection
                            onRowSelectionModelChange={handleSelectionChanged}
                            autoHeight={true}
                            rowHeight={35}
                            initialState={{
                                pagination: { paginationModel: { pageSize: 25 } },
                            }}
                            columns={[
                                {
                                    headerName: 'Name',
                                    field: 'displayName',
                                    flex: 3,
                                },
                                {
                                    headerName: 'Email',
                                    field: 'email',
                                    flex: 3,
                                },
                                {
                                    headerName: 'Primary Phone',
                                    field: 'phone',
                                    flex: 3,
                                },
                                {
                                    headerName: 'Assigned Projects',
                                    field: 'programNames',
                                    flex: 4,
                                },
                            ]}
                            sx={{
                                backgroundColor: 'white'
                            }}
                            getRowClassName={(params) => 'grid-row'} />

                    </div>
                </Col>
            </Row>
            <DeleteConfirmation
                title={`Delete contacts`}
                onDelete={handleDelete}
                onToggle={handleDeleteConfirmationToggle}
                toDelete={deleteConfirmationState.toDelete.map(x => {
                    return x.displayName || '';
                })}
                isOpen={deleteConfirmationState.display}
            />
        </>
    );
};

List.propTypes = {
    data: PropTypes.array,
    onDelete: PropTypes.func,
    onSelect: PropTypes.func,
    onNew: PropTypes.func,
    hideButtons: PropTypes.bool,
    hideAddButton: PropTypes.bool,
    hideSearchButton: PropTypes.bool,
    title: PropTypes.string,
    searchResults: PropTypes.array,
    onAdd: PropTypes.func,
    onSearch: PropTypes.func,
};

export default List;
